export const environment = {
  production: false,
  recaptcha: {
    siteKey: '6LcQAy8mAAAAAMKYHpQvPlTNZ_a2IxvxnFX55rBd'
  },
  
  URL_SERVICIOS: 'https://dev.test.almamedis.cl/api/',
  URL_DOCS: 'https://archivos-almamedis-almamedis.s3.amazonaws.com/desarrollo',
  URL_SERVICIOS_SOCKET: 'https://dev.test.almamedis.cl/',
  URL_SAPHERE: 'https://cdn.saphere.ai/saphere-scan/v2/main.js',
  CUSTOMIZATION_ID: '1b23d3df-c0f2-4fa7-967e-234ba3304430',
  examediClientId: 'ea95644a-e6a6-4fe3-9a9d-c9677170b4f0',
  examediSdkUrl: 'https://staging-sdk.examedi.cl/staging-examedi-app.js',
  ENVIRONMENT: 'desarrollo',
WEBRTC_ICE_SERVERS: {
    iceServers: [
      { urls: 'stun:stun1.almamedis.cl:3478' },
      {
        urls: 'turn:turn1.almamedis.cl:3478',
        username: 'almamedis',
        credential: '%S3Chile%'
      }
    ]
  }
 
};